import { Doughnut, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

// TODO: Add Center Text to Doughnut Chart
// Chart.defaults.DoughnutWithCenterText = Chart.defaults.Doughnut

// Chart.controllers.DoughnutWithCenterText = Chart.controllers.doughnut.extend({
//   beforeDraw: (chart) => { ...code })

// const DoughnutWithCenterText = generateChart('item-coverage-totals', 'DoughnutWithCenterText')

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ["options"],
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  updated() {
    this.renderChart(this.chartData, this.options);
  },
};
